module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "value": _vm.value,
      "title": _vm.modalTitle,
      "width": "760",
      "mask-closable": false,
      "class-name": "recruit-notes-modal"
    },
    on: {
      "on-visible-change": _vm.onVisibleChange
    }
  }, [(_vm.detailLoading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "notes-sub"
  }, [_vm._v("\n    一、面试笔记 · 二、试讲打分\n    "), (_vm.scoreStats.hasScored) ? _c('span', [_vm._v("（总分 " + _vm._s(_vm.scoreStats.sumText) + " · 平均分 " + _vm._s(_vm.scoreStats.avgText) + "）")]) : _vm._e(), _vm._v(" "), (_vm.noteTime) ? _c('span', {
    staticClass: "notes-time"
  }, [_vm._v("最近保存：" + _vm._s(_vm.noteTime) + " " + _vm._s(_vm.noteBy))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "notes-body",
    on: {
      "paste": _vm.onPaste
    }
  }, [_c('div', {
    staticClass: "notes-field"
  }, [_c('div', {
    staticClass: "notes-label"
  }, [_vm._v("上课链接")]), _vm._v(" "), _c('div', {
    staticClass: "class-link-row"
  }, [_c('Input', {
    staticClass: "class-link-input",
    attrs: {
      "placeholder": "https:// 粘贴课堂/会议链接"
    },
    model: {
      value: (_vm.form.classLink),
      callback: function($$v) {
        _vm.$set(_vm.form, "classLink", $$v)
      },
      expression: "form.classLink"
    }
  }), _vm._v(" "), (_vm.classLinkOpenable) ? _c('a', {
    staticClass: "class-link-open",
    attrs: {
      "href": _vm.classLinkHref,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("打开")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "notes-field"
  }, [_c('div', {
    staticClass: "notes-label"
  }, [_vm._v("附件")]), _vm._v(" "), _c('Upload', {
    ref: "attachUpload",
    attrs: {
      "type": "drag",
      "action": _vm.uploadAction,
      "headers": _vm.uploadHeaders,
      "show-upload-list": false,
      "max-size": _vm.maxSizeKb,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.uploadSuccess,
      "on-error": _vm.uploadError,
      "on-exceeded-size": _vm.exceededSize,
      "multiple": ""
    }
  }, [_c('div', {
    staticClass: "upload-drag-inner"
  }, [_c('Icon', {
    staticClass: "upload-drag-icon",
    attrs: {
      "type": "ios-cloud-upload",
      "size": "40"
    }
  }), _vm._v(" "), _c('p', [_vm._v("点击或将文件拖拽到这里上传")]), _vm._v(" "), _c('p', {
    staticClass: "upload-drag-tip"
  }, [_vm._v("也可复制文件后在本弹窗内粘贴上传，单文件不超过 100MB")])], 1)]), _vm._v(" "), (_vm.form.attachments.length) ? _c('ul', {
    staticClass: "attach-list"
  }, _vm._l((_vm.form.attachments), function(file, index) {
    return _c('li', {
      key: file.url + index
    }, [_c('Icon', {
      attrs: {
        "type": "document"
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": file.url,
        "target": "_blank",
        "title": file.name
      }
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('span', {
      staticClass: "attach-size"
    }, [_vm._v(_vm._s(_vm.formatSize(file.size)))]), _vm._v(" "), _c('a', {
      staticClass: "attach-del",
      on: {
        "click": function($event) {
          return _vm.removeAttachment(index)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), 0) : _c('p', {
    staticClass: "notes-empty"
  }, [_vm._v("暂无附件")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "notes-section"
  }, [_c('span', {
    staticClass: "section-no"
  }, [_vm._v("一")]), _vm._v("面试笔记")]), _vm._v(" "), _c('div', {
    staticClass: "notes-panel"
  }, [_c('div', {
    staticClass: "notes-field"
  }, [_c('div', {
    staticClass: "notes-label"
  }, [_vm._v("个人情况 "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "placeholder": "记录个人背景、性格、沟通印象等..."
    },
    model: {
      value: (_vm.form.personalSituation),
      callback: function($$v) {
        _vm.$set(_vm.form, "personalSituation", $$v)
      },
      expression: "form.personalSituation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "notes-field"
  }, [_c('div', {
    staticClass: "notes-label"
  }, [_vm._v("工作情况 "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "placeholder": "记录工作经历、在职状态、可用性等..."
    },
    model: {
      value: (_vm.form.workSituation),
      callback: function($$v) {
        _vm.$set(_vm.form, "workSituation", $$v)
      },
      expression: "form.workSituation"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "notes-label"
  }, [_vm._v("试用期薪资（美元） "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "例如 12 或 10-14"
    },
    model: {
      value: (_vm.form.probationSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "probationSalary", $$v)
      },
      expression: "form.probationSalary"
    }
  }, [_c('span', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_vm._v("$")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "notes-label"
  }, [_vm._v("转正后薪资（美元） "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "例如 15 或 14-18"
    },
    model: {
      value: (_vm.form.regularSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "regularSalary", $$v)
      },
      expression: "form.regularSalary"
    }
  }, [_c('span', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_vm._v("$")])])], 1)], 1)], 1), _vm._v(" "), _c('h3', {
    staticClass: "notes-section"
  }, [_c('span', {
    staticClass: "section-no is-green"
  }, [_vm._v("二")]), _vm._v("试讲打分")]), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "notes-label is-green"
  }, [_vm._v("优点 "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "placeholder": "记录试讲中的亮点和优势..."
    },
    model: {
      value: (_vm.form.demoStrengths),
      callback: function($$v) {
        _vm.$set(_vm.form, "demoStrengths", $$v)
      },
      expression: "form.demoStrengths"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "notes-label is-orange"
  }, [_vm._v("缺点 "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "placeholder": "记录需要改进的地方..."
    },
    model: {
      value: (_vm.form.demoWeaknesses),
      callback: function($$v) {
        _vm.$set(_vm.form, "demoWeaknesses", $$v)
      },
      expression: "form.demoWeaknesses"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "score-head"
  }, [_c('span', {
    staticClass: "notes-label"
  }, [_vm._v("评分标准 "), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', {
    staticClass: "score-tip"
  }, [_vm._v("0 未评 · 1 差 · 2 偏弱 · 3 中等及格 · 3.5 · 4 良好 · 4.5 · 5 优秀")])]), _vm._v(" "), (_vm.scoreStats.hasScored) ? _c('div', {
    staticClass: "score-sum"
  }, [_vm._v("\n      已打分汇总　满分 45 分　总分 "), _c('b', [_vm._v(_vm._s(_vm.scoreStats.sumText))]), _vm._v("　|　平均分 "), _c('b', [_vm._v(_vm._s(_vm.scoreStats.avgText))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "score-panel"
  }, _vm._l((_vm.criteria), function(c) {
    return _c('div', {
      key: c.key,
      staticClass: "score-row"
    }, [_c('span', {
      staticClass: "score-label"
    }, [_vm._v(_vm._s(c.label))]), _vm._v(" "), _c('RadioGroup', {
      attrs: {
        "type": "button",
        "size": "small"
      },
      model: {
        value: (_vm.form.demoScores[c.key]),
        callback: function($$v) {
          _vm.$set(_vm.form.demoScores, c.key, $$v)
        },
        expression: "form.demoScores[c.key]"
      }
    }, _vm._l((_vm.scoreOptions), function(opt) {
      return _c('Radio', {
        key: opt,
        attrs: {
          "label": opt
        }
      }, [_vm._v(_vm._s(opt))])
    }), 1)], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "notes-field"
  }, [_c('div', {
    staticClass: "notes-label"
  }, [_vm._v("备注")]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "补充说明、后续跟进建议等..."
    },
    model: {
      value: (_vm.form.demoRemarks),
      callback: function($$v) {
        _vm.$set(_vm.form, "demoRemarks", $$v)
      },
      expression: "form.demoRemarks"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "notes-complete",
    class: {
      'is-ok': _vm.complete
    }
  }, [_vm._v("\n      " + _vm._s(_vm.complete ? '笔记已齐全，可提交复审' : '带 * 的项全部填写且 9 项打分都大于 0 后，才可提交复审') + "\n    ")]), _vm._v(" "), (_vm.draftHint) ? _c('p', {
    staticClass: "draft-hint"
  }, [_vm._v(_vm._s(_vm.draftHint))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving,
      "disabled": _vm.uploading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f9f6037","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/recruit/modal/RecruitNotesModal.vue
// module id = 1822
// module chunks = 8